import { render } from "./transporterView.vue?vue&type=template&id=4cccce6b&scoped=true"
import script from "./transporterView.vue?vue&type=script&lang=js"
export * from "./transporterView.vue?vue&type=script&lang=js"

import "./transporterView.vue?vue&type=style&index=0&id=4cccce6b&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cccce6b"]])

export default __exports__